<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Usuarios">
          <b-table 
              hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="usuarios" 
              :fields="usuariosFields"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
              <!--<strong>Procesando...</strong>-->
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown 
                  v-if="data.item.usuarioRolId != 1 | data.item.usuarioRolId == 1 & userRolId == 1"
                  variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Usuario</b-dropdown-item>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Usuario</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">    
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> 

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarios/getField',
  mutationType: 'usuarios/updateField',
});

export default {
  name: 'Usuarios',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal, 
  ],
  data: () => {
    return {
      usuariosFields: [
        {
          key: 'username',
          label: 'Usuario',
          sortable: true
        },
        {
          key: 'nombreCompleto',
          sortable: true
        },
        {
          key: 'usuarioRol',
          label: 'Rol',
          sortable: true
        },
        {key: 'inactivo'},
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],
      userRolId: 0,
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'usuarios',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'incluirInactivos'
    ]),
  },
  created() {
    this.userRolId = parseInt(this.$store.getters['user/rolId']);
    
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('usuarios/getUsuarios')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    consultar (item) {
      this.$router.push({ name: 'UsuarioData', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'UsuarioAdd' });
    },
    editar (item) {
      if (item.usuarioRolId != 1 | (item.usuarioRolId == 1 & this.userRolId == 1)) {
        this.$router.push({ name: 'UsuarioEdit', 
                            params: { id: item.id }});
      }
    },
    borrar (item) {
      this.showModalConfirm('¿Desea inactivar el usuario seleccionado?', 
        this.inactivar.bind(this, item.id), 'Si', null, 'No')
    },
    inactivar (usuarioId) {
      this.showSpinner();
      this.$store.dispatch('usuario/inactivar', usuarioId)
        .then(() => this.showModalMsj('El usuario se inactivó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
